// extracted by mini-css-extract-plugin
export default {"discounts-row":"DiscountRow_discounts-row__3mkIu"};